import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { Handle, Position } from 'reactflow'
import { AppTheme } from '../../../../styles/AppTheme'
import { ChatbotNodeHeader, chatbotNodeIcon } from './ChatbotNodeHeader'
import { ChatbotTargetHandle } from './ChatbotTargetHandle'
import { HANDLE_OUT, NODE_TYPE_CONTACT } from './chatbotGraph'

const HANDLE_STYLE = {
  width: 10,
  height: 10,
  background: AppTheme.primaryColor,
  border: '2px solid #ffffff',
}

function tagValues(values) {
  return Array.isArray(values) ? values.map(v => String(v || '').trim()).filter(Boolean) : []
}

function truncate(text, max) {
  const s = String(text || '').trim()
  if (!s) return ''
  if (s.length <= max) return s
  return s.slice(0, max) + '…'
}

function TagPills(props) {
  const list = tagValues(props.values)
  if (!list.length) return null
  const shown = list.slice(0, 4)
  const extra = list.length - shown.length
  return (
    <div className={css(Styles.pills)}>
      {shown.map((tag, i) => (
        <span key={i} className={css(Styles.pill)}>{truncate(tag, 16)}</span>
      ))}
      {extra > 0 ? <span className={css(Styles.pill)}>+{extra}</span> : null}
    </div>
  )
}

function ContactBody(props) {
  const data = props.data || {}
  const state = String(data.state || '').trim()
  const statusLabel = data.statusLabel || state
  const add = tagValues(data.tags)
  const remove = tagValues(data['tags!'])
  if (!state && !add.length && !remove.length) {
    return <div className={css(Styles.empty)}>No changes yet</div>
  }
  return (
    <div className={css(Styles.rows)}>
      {state ? (
        <div>
          <div className={css(Styles.label)}>Next Status</div>
          <div className={css(Styles.value)}>{statusLabel}</div>
        </div>
      ) : null}
      {add.length ? (
        <div>
          <div className={css(Styles.label)}>Add Tags</div>
          <TagPills values={add} />
        </div>
      ) : null}
      {remove.length ? (
        <div>
          <div className={css(Styles.label)}>Remove Tags</div>
          <TagPills values={remove} />
        </div>
      ) : null}
    </div>
  )
}

export function ChatbotContactNode(props) {
  const data = props.data || {}
  return (
    <div className={css(Styles.card, props.selected && Styles.cardSelected)}>
      <ChatbotTargetHandle hidden={!!data.isStartNode} style={HANDLE_STYLE} />
      <ChatbotNodeHeader
        title='Update Contact'
        icon={chatbotNodeIcon(NODE_TYPE_CONTACT)}
        tone='crm'
        isStartNode={data.isStartNode}
        onDelete={data.onDelete}
        onDuplicate={data.onDuplicate}
        onSetStartNode={data.onSetStartNode}
      />
      <div className={css(Styles.body)}>
        <ContactBody data={data} />
      </div>
      <Handle
        type='source'
        position={Position.Right}
        id={HANDLE_OUT}
        style={HANDLE_STYLE}
      />
    </div>
  )
}

const Styles = StyleSheet.create({
  card: {
    width: 240,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  cardSelected: {
    borderColor: AppTheme.primaryColor,
    boxShadow: '0 0 0 3px ' + AppTheme.primaryColor + '33',
  },
  body: {
    padding: '10px 12px 12px',
    textAlign: 'left',
  },
  rows: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  label: {
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 600,
    color: '#6B7280',
    marginBottom: 4,
  },
  value: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#222222',
    wordBreak: 'break-word',
  },
  pills: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 4,
  },
  pill: {
    fontSize: 11,
    lineHeight: '16px',
    fontWeight: 600,
    color: '#374151',
    backgroundColor: '#F3F4F6',
    padding: '1px 8px',
    borderRadius: 999,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  empty: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#6B7280',
  },
})
